import ServiceRoute from "./ServiceRoute";

export default ServiceRoute;
